export default [
  {
    path: '/v2/currencies',
    name: 'currency',
    meta: { requiresAuth: true },
    component: () => import('./views/index.vue')
  }
]
